<template>
  <div class="my-interview-box">
    <div class="my-interview">
      <wy-card style="min-height: 95%;">
        <header>
          <div class="header" @click="selectFn">
            <span class="title">{{jobfair.name}}</span>
            <span class="iconfont icon-download"></span>
          </div>
        </header>
        <section>
          <tabs type="card" v-model="current_type" @change="tabsChangeFn">
            <tab :title="list.title" :name="key" v-for="(list, key) in list_data" :key="key">
              <div>
                <pull-refresh v-model="list.refreshLoading" @refresh="onRefresh(key)">
                  <list
                    v-if="list.data.length > 0"
                    v-model="list.loading"
                    :finished="list.finished"
                    :error.sync="list.error"
                    error-text="请求失败，点击重新加载"
                    finished-text="没有更多了"
                    @load="getList(key)"
                  >
                    <face
                      v-if="key === 'face'"
                      :list="list.data"
                      @refresh="onRefresh(key, true)"
                      :jobfair="jobfair.data"
                    ></face>
                    <invitation
                      v-if="key === 'wait'"
                      :list="list.data"
                      @refresh="invitationOnRefresh"
                    ></invitation>
                  </list>
                </pull-refresh>
              </div>
              <div class="null" v-if="list.finished && list.data.length <= 0">
                <p>您目前还没有任何面试安排</p>
                <p>快去申请面试吧~</p>
              </div>
            </tab>
          </tabs>
        </section>
        <section style="padding-top: 0.3rem;">
          <van-button
            type="info"
            @click="signUpFn"
            v-if="!(jobfair.data && jobfair.data.current_status == '已结束')"
          >申请面试</van-button>
        </section>
      </wy-card>

      <action-sheet
        v-model="showAction"
        :actions="actionsList"
        @select="onSelectAction"
        title="选择双选会"
        cancel-text="取消"
      />
    </div>
  </div>
</template>

<script>
import { ActionSheet, List, PullRefresh, Tabs, Tab } from "vant";
import WyCard from "@/components/WyCard";
import { mapState } from "vuex";
import Invitation from "./Invitation";
import Face from "./Face";

export default {
  name: "my",
  components: {
    ActionSheet,
    List,
    PullRefresh,
    WyCard,
    Tabs,
    Tab,
    Invitation,
    Face
  },
  computed: {
    ...mapState({
      route: state => state.route,
      sign: state => state.sign,
      myApplyObj: state => state.myApplyObj,
      jobfair: state => state.checkedjobfair,
      change_jobfair: state => state.change_jobfair,
      refreshHome: state => state.refreshHome
    })
  },
  data() {
    return {
      showAction: false,
      actionsList: [],
      list_data: {
        face: {
          title: "待面试",
          refreshLoading: false,
          finished: false,
          loading: false,
          error: false,
          interfaceName: "video_invitation",
          params: {
            pageNo: 1,
            pageSize: 15,
            video_jobfair_id: ""
          },
          data: []
        },
        wait: {
          title: "待确认",
          refreshLoading: false,
          finished: false,
          loading: false,
          error: false,
          interfaceName: "history_invitation",
          params: {
            pageNo: 1,
            pageSize: 15,
            video_jobfair_id: ""
          },
          data: []
        }
      },
      current_type: "face"
    };
  },
  created() {
    this.$store.commit("updateQuickFace", false);
    this.$store.commit("setSubTitle", { title: "面试" });

    const current_type = this.$util.getQueryString("current_type");
    if (this.list_data[current_type]){
      sessionStorage.setItem("current_type", current_type);
      this.current_type = current_type;
    }
  },
  mounted() {
    this.preinit();
  },
  methods: {
    preinit() {
      const { sign } = this;

      this.$store.dispatch("getMyApply", { sign }).then(res => {
        const { data, code } = res;
        if (code === 1 && data && data.list.length > 0) {
          this.init();
        } else {
          this.$dialog
            .alert({
              title: "未报名",
              message: "您还未报名视频双选会,快去报名吧!"
            })
            .then(() => {
              this.$router.push({ path: "/" });
            });
        }
      });
    },
    initType(current_type) {
      if (!current_type) {
        current_type = sessionStorage.getItem("current_type");
      }

      if (this.list_data[current_type] && this.current_type != current_type) {
        this.current_type = current_type;
        return true;
      } else {
        return false;
      }
    },
    init() {
      const changeType = this.initType();

      const { myApplyObj, jobfair, change_jobfair } = this;

      let actionsList = [];
      let modify_time = 0;
      for (let key in myApplyObj) {
        let item = myApplyObj[key];
        let newItem = {
          name: item.video_jobfair_name,
          video_jobfair_id: item.video_jobfair_id,
          data: item
        };

        // TODO:: 已结束的是否不显示??

        // 按照modify_time排序
        if (item.modify_time > modify_time) {
          modify_time = item.modify_time;
          actionsList.unshift(newItem);
        } else {
          actionsList.push(newItem);
        }

        if (
          parseInt(change_jobfair.video_jobfair_id) ===
          item.video_jobfair_id * 1
        ) {
          this.$store.commit("updateCheckedjobfair", newItem);
        }
      }

      if (!jobfair.video_jobfair_id && actionsList.length > 0) {
        this.$store.commit("updateCheckedjobfair", actionsList[0]);
      }

      this.actionsList = actionsList;

      if (changeType === false) {
        // 如果没有改变current_type， 那么需要调用列表
        this.getList();
      }
    },
    onSelectAction(item) {
      this.$store.commit("updateCheckedjobfair", item);
      this.showAction = false;

      this.refreshList("face");
      this.refreshList("wait");
    },
    selectFn() {
      this.showAction = true;
    },
    invitationOnRefresh(param) {
      const { state } = param;
      this.onRefresh("wait", true);

      if (parseInt(state) === 1) {
        this.onRefresh("face", true);
      }
    },
    onRefresh(type, silent) {
      let that = this;

      that.$set(that.list_data[type].params, "page", 1);
      that.getList(type).then(res => {
        const { code } = res || {};

        if (silent) {
          return;
        }

        if (code === 1) {
          setTimeout(() => {
            that.$set(that.list_data[type], "refreshLoading", false);
            that.$notify({
              message: "刷新完成",
              type: "primary"
            });
          }, 1000);
        }
      });
    },
    getList(type) {
      let that = this;

      const { sign, jobfair, current_type } = this;

      if (!type) {
        type = current_type;
      }

      const { video_jobfair_id } = jobfair;
      let { params, interfaceName } = this.list_data[type];

      params.sign = sign;
      params.video_jobfair_id = video_jobfair_id;

      return new Promise(resolve => {
        if (!video_jobfair_id) {
          resolve();
          return;
        }

        that.$util.get("kzp_video_jobfair", interfaceName, params).then(res => {
          const { code, msg, data } = res;
          // 加载状态结束
          that.$set(that.list_data[type], "loading", false);
          if (code === 1) {
            const { items, total } = data;

            if (params.pageNo === 1) {
              that.$set(that.list_data[type], "finished", false);
              that.$set(that.list_data[type], "data", items);
            } else {
              that.$set(that.list_data[type], "data", [
                ...that.list_data[type].data,
                ...items
              ]);
            }

            // 数据全部加载完成
            if (
              items.length < params.pagesize ||
              that.list_data[type].data.length >= total
            ) {
              that.$set(that.list_data[type], "finished", true);
            } else {
              that.$set(that.list_data[type].params, "page", params.page + 1);
            }
          } else {
            that.$set(that.list_data[type], "error", true);
            that.$notify({
              message: msg || "获取数据失败，请稍后再试！",
              type: "danger"
            });
          }

          resolve(res);
        });
      });
    },
    refreshList(type) {
      if (!type) {
        type = this.current_type;
      }
      this.$set(this.list_data[type].params, "page", 1);
      this.getList(type);
    },
    signUpFn() {
      let that = this;
      const { myApplyObj, sign, jobfair } = that;

      const { video_jobfair_id, name } = jobfair;

      // 判断是否已报名
      if (!myApplyObj[video_jobfair_id]) {
        that.$store
          .dispatch("registerJobfair", { sign, video_jobfair_id })
          .then(res => {
            const { code, msg } = res;
            if (code === 1) {
              that.toCompany(video_jobfair_id, name);
            } else {
              that.$notify({
                message: msg || "获取数据失败，请稍后再试！",
                type: "danger"
              });
            }
          });
        return;
      }

      that.toCompany(video_jobfair_id, name);
    },
    toCompany(video_jobfair_id, title) {
      this.$router.push({
        path:
          "/sub/company?video_jobfair_id=" +
          video_jobfair_id +
          "&title=" +
          title
      });
    },
    tabsChangeFn(name) {
      this.current_type = name;
      sessionStorage.setItem("current_type", name);

      if (this.list_data[name].data.length <= 0) {
        this.refreshList();
      }
    }
  },
  watch: {
    "change_jobfair.video_jobfair_id": {
      handler(val, oldVal) {
        if (val && val !== oldVal) {
          if (this.myApplyObj[val]) {
            this.init();
          } else {
            this.preinit();
          }
        }
      },
      deep: true
    },
    "refreshHome": {
      handler(val, oldVal) {
        if (val && val.wait !== undefined && oldVal && oldVal !== undefined && val.wait !== oldVal.wait) {
          this.invitationOnRefresh()
          this.$$store.commit('updateRefreshHome', {key: 'wait', val: false})
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.van-step__circle {
  width: 0.09rem;
  height: 0.09rem;
}

.van-steps--vertical {
  padding-left: 0.22rem;
  text-align: left;

  h3 {
    line-height: 0.2rem;
    font-size: 0.14rem;
    color: #171717;
    margin-bottom: 0.05rem !important;
  }

  p {
    margin-bottom: 0.02rem;
  }
}

$active: #439bff;
$finish: #999;
$finishBg: #f3f3f3;

.van-step--process {
  h3 {
    color: $active;
  }

  &::after {
    border-color: $active;
  }
  .van-button--plain.van-button--info {
    background-color: $active;
    color: #fff;
  }
}

.van-step--finish {
  color: $finish;

  .van-step__circle,
  .van-step__line {
    background-color: $finishBg;
  }

  .van-button--plain.van-button--info {
    color: $finish;
    border-color: $finishBg;
  }

  .can-cancel {
    .van-button--plain.van-button--info {
      color: $active;
      border-color: $active;
    }
  }
}

.no-cancel {
  .van-button--plain.van-button--info {
    color: $finish;
    border-color: $finishBg;
  }
}

.van-action-sheet {
  .van-action-sheet__item {
    @include over-ellipsis();
  }
}

.van-tabs__nav--card {
  margin: 0;
  border-color: $active;
}

.van-tabs__nav--card .van-tab.van-tab--active {
  background-color: $active;
}

.van-tabs__nav--card .van-tab {
  color: $active;
  border-color: $active;
}

.van-tabs__content {
  padding-top: 0.1rem;
}
</style>

<style lang="scss" scoped>
.my-interview-box {
  height: 100%;
}
.my-interview {
  height: 100%;
  padding: 0.15rem;
  background-color: #f3f3f3;

  @include box-sizing(border-box);

  header {
    line-height: 0.22rem;
    text-align: left;
    margin-bottom: 0.1rem;

    .header {
      position: relative;
      padding-right: 0.15rem;
      display: inline-block;
      max-width: 90%;
      @include over-ellipsis();

      .icon-download {
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    .title {
      color: #171717;
      font-size: 0.16rem;
      font-weight: bold;
    }
    .icon-download {
      font-size: 0.12rem;
      display: inline-block;
      @include transform(scale(0.5, 0.5));
    }
  }

  .null {
    padding-top: 1rem;
    color: #999;
    line-height: 0.2rem;
    font-size: 0.14rem;
  }
}
</style>
